// Async boundary so Module Federation shared scopes initialize before the
// orchestrator (and any loaded remote) runs.
import("./bootstrap");
